// 'library' namespace — keys are prefixed 'library.'.
const ru: Record<string, string> = {
  'library.teacherVerified': 'Проверено преподавателем',
  'library.published': 'Опубликованное пособие',
  'library.unverifiedShort': 'не проверено',
  'library.userUploaded': 'Добавлено пользователем',

  'library.title': 'Библиотека',
  'library.subtitle': 'Письма уровня A2 для копирования, воспроизведения, свободного письма и экзамена.',
  'library.bannerTitle': 'Все текущие письма — оригинальные AI-черновики, ожидающие проверки преподавателем.',
  'library.bannerText':
    'Это не официальные экзаменационные задания прошлых лет. Задания и образцовые ответы написаны для Greek Notebook и помечены как непроверенные, пока их не проверит квалифицированный преподаватель греческого. Официальные источники приведены только как ориентир — их тексты не копировались.',
  'library.sourcesTitle': 'Источники',
  'library.sourcesSubtitle': 'Ссылки, лицензии и даты проверки',
  'library.license': 'Лицензия',
  'library.verified': 'Проверено',
  'library.verifiedOn': 'Проверено {date}',
  'library.notVerified': 'не проверено',
  'library.link': 'Ссылка',
  'library.year': 'Год',
  'library.source': 'Источник',

  'library.searchPlaceholder': 'Поиск по названию или заданию…',
  'library.filterMode': 'Режим',
  'library.filterTopic': 'Тема',
  'library.filterRegister': 'Стиль',
  'library.filterSource': 'Тип источника',
  'library.allModes': 'Все режимы',
  'library.allTopics': 'Все темы',
  'library.allRegisters': 'Любой стиль',
  'library.allSources': 'Все источники',
  'library.resetFilters': 'Сбросить',
  'library.viewLabel': 'Вид',
  'library.byTopic': 'По темам',
  'library.alphabetical': 'Списком',
  'library.shown': 'Показано: {n}',
  'library.moreAvailable': 'есть ещё',
  'library.noResults': 'Ничего не найдено',
  'library.noResultsText': 'Попробуйте другой запрос или сбросьте фильтры.',
  'library.empty': 'Библиотека пока пуста',
  'library.emptyText': 'Задания появятся здесь после импорта контента администратором.',

  'library.word.one': 'слово',
  'library.word.few': 'слова',
  'library.word.many': 'слов',
  'library.difficultyOf': 'Сложность {n} из 5',
  'library.attempts': 'Попыток: {n}',
  'library.best': 'лучшая',
  'library.notTried': 'Ещё не пробовали',

  'library.letterType.email': 'Email',
  'library.letterType.letter': 'Письмо',
  'library.letterType.note': 'Записка',
  'library.letterType.message': 'Сообщение',
  'library.letterType.postcard': 'Открытка',

  'library.sourceType.official_sample': 'Официальный образец',
  'library.sourceType.published_practice': 'Опубликованное пособие',
  'library.sourceType.original_ai_draft': 'Оригинальный AI-черновик',
  'library.sourceType.teacher_verified': 'Проверено преподавателем',
  'library.sourceType.user_uploaded': 'Загружено пользователем',

  'library.promptProvenance.verified_official': 'Задание сверено с официальным источником',
  'library.promptProvenance.adapted_from_official': 'Задание адаптировано по официальному образцу',
  'library.promptProvenance.original': 'Оригинальное задание',
  'library.review.unverified': 'Не проверено преподавателем',
  'library.review.teacher_reviewed': 'Проверено преподавателем',
  'library.review.verified': 'Проверено',
  'library.authoredBy.ai_draft': 'Написано AI',
  'library.authoredBy.teacher': 'Написано преподавателем',
  'library.authoredBy.official': 'Официальный ответ',

  'library.task': 'Задание',
  'library.openInLibrary': 'Открыть в библиотеке',
  'library.backToLibrary': 'Библиотека',
  'library.notFound': 'Задание не найдено',
  'library.notFoundText': 'Возможно, оно было удалено или ссылка неверна.',
  'library.prompt': 'Задание',
  'library.requiredPoints': 'Что нужно написать',
  'library.wordLimits': 'Объём: {min}–{max} слов',
  'library.modelLength': 'образец: {words}',
  'library.showTranslation': 'Перевод',
  'library.hideTranslation': 'Скрыть перевод',
  'library.reference': 'Образец',
  'library.modelAnswer': 'Образцовый ответ',
  'library.noReference': 'Для этого задания пока нет образцового ответа.',
  'library.referenceHidden': 'Образец скрыт: у вас идёт строгая попытка воспроизведения по этому заданию. Он снова будет доступен после отправки.',
  'library.version': 'Версия {v}',
  'library.versions': 'Версии образца',
  'library.versionsHint': 'Каждая попытка закрепляет версию, с которой начиналась, — правки образца не меняют прошлые результаты.',
  'library.current': 'текущая',
  'library.vocabulary': 'Словарь',
  'library.learningGoals': 'Цели',
  'library.tags': 'Теги',
  'library.provenance': 'Происхождение и права',
  'library.practiceThis': 'Практиковаться',
  'library.usedInExam': 'Используется в экзамене',
  'library.toExam': 'К экзамену',
  'library.yourAttempts': 'Ваши попытки',
  'library.attemptsLabel': 'попыток',
  'library.bestCopy': 'лучшая точность копии',
  'library.noAttempts': 'Вы ещё не работали с этим заданием.',
};
const en: Record<string, string> = {
  'library.teacherVerified': 'Teacher verified',
  'library.published': 'Published practice',
  'library.unverifiedShort': 'unverified',
  'library.userUploaded': 'User uploaded',

  'library.title': 'Library',
  'library.subtitle': 'A2 letters for copying, recall, free writing and the exam.',
  'library.bannerTitle': 'All current letters are original AI drafts awaiting teacher review.',
  'library.bannerText':
    'They are not official past exam papers. Tasks and model answers were written for Greek Notebook and stay marked unverified until a qualified Greek teacher reviews them. Official sources are linked for reference only — none of their text was copied.',
  'library.sourcesTitle': 'Sources',
  'library.sourcesSubtitle': 'Links, licences and verification dates',
  'library.license': 'Licence',
  'library.verified': 'Verified',
  'library.verifiedOn': 'Verified {date}',
  'library.notVerified': 'not verified',
  'library.link': 'Link',
  'library.year': 'Year',
  'library.source': 'Source',

  'library.searchPlaceholder': 'Search titles and prompts…',
  'library.filterMode': 'Mode',
  'library.filterTopic': 'Topic',
  'library.filterRegister': 'Register',
  'library.filterSource': 'Source type',
  'library.allModes': 'All modes',
  'library.allTopics': 'All topics',
  'library.allRegisters': 'Any register',
  'library.allSources': 'All sources',
  'library.resetFilters': 'Reset',
  'library.viewLabel': 'View',
  'library.byTopic': 'By topic',
  'library.alphabetical': 'List',
  'library.shown': 'Showing {n}',
  'library.moreAvailable': 'more available',
  'library.noResults': 'Nothing found',
  'library.noResultsText': 'Try another search or reset the filters.',
  'library.empty': 'The library is empty',
  'library.emptyText': 'Tasks appear here once an admin imports content.',

  'library.word.one': 'word',
  'library.word.few': 'words',
  'library.word.many': 'words',
  'library.difficultyOf': 'Difficulty {n} of 5',
  'library.attempts': 'Attempts: {n}',
  'library.best': 'best',
  'library.notTried': 'Not tried yet',

  'library.letterType.email': 'Email',
  'library.letterType.letter': 'Letter',
  'library.letterType.note': 'Note',
  'library.letterType.message': 'Message',
  'library.letterType.postcard': 'Postcard',

  'library.sourceType.official_sample': 'Official sample',
  'library.sourceType.published_practice': 'Published practice',
  'library.sourceType.original_ai_draft': 'Original AI draft',
  'library.sourceType.teacher_verified': 'Teacher verified',
  'library.sourceType.user_uploaded': 'User uploaded',

  'library.promptProvenance.verified_official': 'Prompt verified against an official source',
  'library.promptProvenance.adapted_from_official': 'Prompt adapted from an official sample',
  'library.promptProvenance.original': 'Original prompt',
  'library.review.unverified': 'Not reviewed by a teacher',
  'library.review.teacher_reviewed': 'Teacher reviewed',
  'library.review.verified': 'Verified',
  'library.authoredBy.ai_draft': 'Written by AI',
  'library.authoredBy.teacher': 'Written by a teacher',
  'library.authoredBy.official': 'Official answer',

  'library.task': 'Task',
  'library.openInLibrary': 'Open in library',
  'library.backToLibrary': 'Library',
  'library.notFound': 'Task not found',
  'library.notFoundText': 'It may have been removed, or the link is wrong.',
  'library.prompt': 'Task',
  'library.requiredPoints': 'What to include',
  'library.wordLimits': 'Length: {min}–{max} words',
  'library.modelLength': 'model: {words}',
  'library.showTranslation': 'Translation',
  'library.hideTranslation': 'Hide translation',
  'library.reference': 'Model text',
  'library.modelAnswer': 'Model answer',
  'library.noReference': 'This task has no model answer yet.',
  'library.referenceHidden': 'Hidden: you have a strict recall attempt in progress for this task. It becomes available again once you submit.',
  'library.version': 'Version {v}',
  'library.versions': 'Model text versions',
  'library.versionsHint': 'Each attempt pins the version it started with — edits to the model never change past results.',
  'library.current': 'current',
  'library.vocabulary': 'Vocabulary',
  'library.learningGoals': 'Goals',
  'library.tags': 'Tags',
  'library.provenance': 'Provenance & rights',
  'library.practiceThis': 'Practise',
  'library.usedInExam': 'Used in the exam',
  'library.toExam': 'Go to exam',
  'library.yourAttempts': 'Your attempts',
  'library.attemptsLabel': 'attempts',
  'library.bestCopy': 'best copy accuracy',
  'library.noAttempts': 'You have not worked on this task yet.',
};
export default { ru, en };
